export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إكتشف أكثر"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يخفي"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور المتاحة"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور النشطة"])}
        }
      },
      "ar-EG": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إكتشف أكثر"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يخفي"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور المتاحة"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور النشطة"])}
        }
      },
      "ar-SA": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إكتشف أكثر"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يخفي"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور المتاحة"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المحاور النشطة"])}
        }
      },
      "de-DE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr entdecken"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausblenden"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verfügbare Hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktive Hubs"])}
        }
      },
      "de-AT": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr entdecken"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausblenden"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verfügbare Hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktive Hubs"])}
        }
      },
      "de-CH": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr entdecken"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausblenden"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verfügbare Hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktive Hubs"])}
        }
      },
      "en-US": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover More"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active Hubs"])}
        }
      },
      "en-GB": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover More"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active Hubs"])}
        }
      },
      "it-IT": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scopri di più"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nascondere"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hub disponibili"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hub attivi"])}
        }
      },
      "fr-FR": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir plus"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cacher"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponibles"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs actifs"])}
        }
      },
      "es-ES": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descubrir más"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocultar"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponibles"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs activos"])}
        }
      },
      "pl-PL": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dowiedz się więcej"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukrywać"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostępne koncentratory"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywne centra"])}
        }
      },
      "nl-NL": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontdek meer"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verbergen"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beschikbare hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actieve hubs"])}
        }
      },
      "bg-BG": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Открий повече"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Крия"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налични хъбове"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активни центрове"])}
        }
      },
      "bs-BA": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otkrijte više"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sakrij se"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostupna čvorišta"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivna čvorišta"])}
        }
      },
      "da-DK": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opdag mere"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skjule"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilgængelige hubs"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktive hubs"])}
        }
      },
      "et-EE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avastage rohkem"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peida"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saadaval jaoturid"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiivsed keskused"])}
        }
      },
      "fi-FI": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löydä lisää"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piilottaa"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käytettävissä olevat keskittimet"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiiviset keskittimet"])}
        }
      },
      "el-GR": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανακάλυψε περισσότερα"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κρύβω"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαθέσιμοι κόμβοι"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοί κόμβοι"])}
        }
      },
      "he-IL": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לגלות עוד"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["להתחבא"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["רכזות זמינות"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["רכזות פעילות"])}
        }
      },
      "ga-IE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faigh amach níos mó"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ceilt"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moil ar Fáil"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moil Ghníomhacha"])}
        }
      },
      "ja-JP": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もっと発見する"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隠れる"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用可能なハブ"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブハブ"])}
        }
      },
      "hr-HR": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otkrij više"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sakriti"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostupni koncentratori"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivni koncentratori"])}
        }
      },
      "lv-LV": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atklājiet vairāk"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slēpt"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pieejamie centrmezgli"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktīvie centrmezgli"])}
        }
      },
      "lt-LT": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atraskite daugiau"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slėpti"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galimi centrai"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktyvūs centrai"])}
        }
      },
      "pt-PT": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descubra mais"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esconder"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponíveis"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs Ativos"])}
        }
      },
      "ro-RO": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descopera mai mult"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ascunde"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hub-uri disponibile"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hub-uri active"])}
        }
      },
      "ru-RU": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Узнать больше"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скрывать"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступные концентраторы"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активные концентраторы"])}
        }
      },
      "sv-SE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upptäck mer"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dölj"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tillgängliga hubbar"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiva hubbar"])}
        }
      },
      "sk-SK": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objavte viac"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skryť"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostupné rozbočovače"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktívne centrá"])}
        }
      },
      "cs-CZ": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objevte více"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skrýt"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dostupné rozbočovače"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivní centra"])}
        }
      },
      "tr-TR": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daha fazlasını keşfet"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gizlemek"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanılabilir Hub'lar"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkin Hub'lar"])}
        }
      },
      "hu-HU": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fedezz fel többet"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elrejt"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elérhető elosztók"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktív központok"])}
        }
      },
      "fr-BE": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir plus"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cacher"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponibles"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs actifs"])}
        }
      },
      "fr-LU": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir plus"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cacher"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponibles"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs actifs"])}
        }
      },
      "mt-MT": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopri aktar"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aħbi"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs disponibbli"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubs attivi"])}
        }
      },
      "sl-SI": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odkrijte več"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skrij se"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vozlišča, ki so na voljo"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivna vozlišča"])}
        }
      },
      "el-CY": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανακάλυψε περισσότερα"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κρύβω"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαθέσιμοι κόμβοι"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοί κόμβοι"])}
        }
      },
      "tr-CY": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daha fazlasını keşfet"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gizlemek"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanılabilir Hub'lar"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkin Hub'lar"])}
        }
      },
      "uk-UA": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дізнайтеся більше"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приховати"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Наявні хаби"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активні концентратори"])}
        }
      },
      "zh-CN": {
        "exploreMore": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发现更多"])}
        },
        "showLess": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐藏"])}
        },
        "availableApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用集线器"])}
        },
        "activeApplications": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动集线器"])}
        }
      }
    }
  })
}
